import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { AutoApproveTimesheetHoursOption, ChapterRadioButtonData } from '@app/+onboarding/chapters/chapter.model';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RadioComponent } from '@sb/ui/radio';
import { RadioGroupComponent } from '@sb/ui/radio-group';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'time-tracking-auto-approve-schedule',
  imports: [OnboardingChapterModule, TranslatePipe, RadioComponent, RadioGroupComponent, ReactiveFormsModule],
  templateUrl: './time-tracking-auto-approve-schedule.component.html',
})
export class TimeTrackingAutoApproveScheduleComponent {
  private translate = inject(TranslateService);

  autoApproveHours = new FormControl(null, Validators.required);

  autoApproveHoursOptions: ChapterRadioButtonData[] = [
    {
      value: AutoApproveTimesheetHoursOption.YES,
      label: this.translate.instant('Yes, auto-approve hours'),
      description: this.translate.instant('Auto-approved timesheets are created from your schedule.'),
    },
    {
      value: AutoApproveTimesheetHoursOption.NO,
      label: this.translate.instant('No, do not auto-approve'),
      description: this.translate.instant("Employees' hours are logged but timesheets require your manual approval."),
    },
  ];

  @Input()
  nextButtonLoading: boolean;

  @Output()
  next = new EventEmitter<AutoApproveTimesheetHoursOption>();

  onNext() {
    if (this.autoApproveHours.valid) {
      this.next.emit(this.autoApproveHours.value);
    }
  }
}
